/**
 * @ngdoc service
 * @name proximus.core.config.config:ConfigurationService
 * @description
 * # ConfigurationService
 *  Used to provide configuration to entity manager which is a singleton
 */
export default class ConfigurationService {
    //Note: Implement this via es6 getters and setters?
    configure(configuration) {
        this.configuration = configuration;
    }
    getApplicationName() {
        return this.configuration.application.applicationName;
    }
    getApplicationVersion() {
        return this.configuration.application.applicationVersion;
    }
    getApplicationVersionStorageStrategy() {
        return this.configuration.application.versionStorageStrategyId;
    }
    onApplicationVersionChange() {
        return this.configuration.application.onApplicationVersionChanged();
    }
    clearStorageIfVersionIsMissing() {
        return this.configuration.application.clearStorageIfVersionIsMissing;
    }
    getStorageStrategies() {
        return this.configuration.storageStrategies;
    }
    getSelectedLanguage() {
        return this.configuration.language.selectLanguageFunction();
    }
    onErrorCallback(entity) {
        var _a;
        return (_a = this.configuration) === null || _a === void 0 ? void 0 : _a.onErrorCallback(entity);
    }
    getLanguageStorageStrategy() {
        return this.configuration.language.languageStorageStrategyId;
    }
    isOnline() {
        return this.configuration.isOnline ? this.configuration.isOnline() : Promise.resolve(true);
    }
    getJwtStorageStrategy() {
        return this.configuration.jwtStorageStrategyId;
    }
    getDefaultEntityConfiguration() {
        return this.configuration.defaultEntityConfiguration;
    }
    getBaseURL() {
        return this.configuration.baseURL || '';
    }
    getRequestTimeout() {
        return this.configuration.timeout;
    }
    getSelectedEncryptionStrategy() {
        return this.configuration.selectedEncryptionStrategy;
    }
    isEnableInterceptor() {
        return this.configuration.enableInterceptor || false;
    }
}
